import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Paths } from '~admin/route';
import { LogoutButton } from '~admin/view/components/auth/logout-button.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { Button } from '~common/components/button/button.component';
import { AnonymousIcon } from '~web/view/components/ui/icon/anonymous.icon';
import { DateIcon } from '~web/view/components/ui/icon/date.icon';
import { Logo } from '~common/components/icon/logo.icon';
import { PlusIcon } from '~web/view/components/ui/icon/plus.icon';
import { LinkBox } from '~web/view/components/ui/link-box.component';
import { Span } from '~common/components/span.component';

export const NavigationDrawer: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Menu>
        <Logo />
        <LinkBox to={Paths.tool.createEvent}>
          <Button>
            <IconBox>
              <PlusIcon />
            </IconBox>
            {t('navigation.buttons.createEvent')}
          </Button>
        </LinkBox>
        <LinkBox to={Paths.tool.events}>
          <IconBox>
            <DateIcon width={20} height={20} />
          </IconBox>
          <LinkText>{t('navigation.buttons.viewEvents')}</LinkText>
        </LinkBox>
        <LinkBox to={Paths.tool.clients}>
          <IconBox>
            <AnonymousIcon width={20} height={20} />
          </IconBox>
          <LinkText>{t('navigation.buttons.manageClients')}</LinkText>
        </LinkBox>
      </Menu>
      <LogoutButton />
    </Container>
  );
};

const Container = styled(Column)`
  width: 100%;
  height: 100%;
  max-width: 285px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 30px 29px;
  background: ${(props): string => props.theme.colors.gray.v20};
`;

const Menu = styled(Column)`
  align-items: flex-start;
  > a:not(:first-child) {
    margin-top: 32px;
  }
`;

const IconBox = styled(Box)`
  margin-right: 12px;
`;

const LinkText = styled(Span)`
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.5px;
`;



// WEBPACK FOOTER //
// ./view/components/core/navigation-drawer.component.tsx